class StateFilter {
    constructor() {
        console.log("INIT FILTER")
        this.regex = /(<([^>]+)>)/ig
        this.stateList = new Set();
        this.main = document.getElementById('MainContent');
        this.firstTeamSection = document.querySelector(".section--multicolumn")
        this.firstTeamSectionList = this.firstTeamSection.querySelector(".multicolumn-list")
        this.teamList = document.getElementsByClassName('multicolumn-list__item grid__item')
        this.filterOptions = []

        this.filterSelect = document.createElement("select")
    }

    initFilter() {
        this.clearFirstSectionList()
        this.generateFilterFromMemberList()
        this.removeOldSections()
        this.main.prepend(this.firstTeamSection)
        this.generateFilterDropDown()
        this.initFilterEvents()
    }

    clearFirstSectionList() {
        this.firstTeamSectionList.innerHTML = ""
    }
    kebabCase (string){
        return string
            .replace(/([a-z])([A-Z])/g, "$1-$2")
            .replace(/[\s_]+/g, '-')
            .toLowerCase();
    }
    generateFilterFromMemberList() {

        for (let person of this.teamList) {
            const typeSet = person.querySelector('.typeset > p')
            if(!typeSet) continue
            const personLocation = typeSet.innerHTML.split(",")
            if (personLocation.length > 2) {
                const state = personLocation.pop().trim().replace(this.regex, "")
                this.stateList.add(state)
                person.classList.add(`filter-${this.kebabCase(state)}`)
            }
            this.firstTeamSectionList.append(person)
        }
        this.filterOptions = Array.from(this.stateList)
        this.filterOptions.sort()
    }

    removeOldSections() {
        console.log("remove old sections")
        while (this.main.querySelector(".section--multicolumn")) this.main.removeChild(this.main.firstChild);
    }

    generateFilterOption(value, text) {
        const option = document.createElement("option")
        option.value = value
        option.text = text
        return option
    }

    generateAllFilterOptions() {
        for (let filterItem of this.filterOptions) {
            this.filterSelect.append(this.generateFilterOption(`filter-${this.kebabCase(filterItem)}`, filterItem))
        }
    }

    generateFilterWrapper() {
        const filterWrapper = document.createElement("div")
        filterWrapper.classList.add("filter-wrapper")

        const filterLabel = document.createElement("label")
        filterLabel.innerText = "Filter by state"
        filterLabel.setAttribute('for', "filter-by-state")

        filterWrapper.append(filterLabel)
        filterWrapper.append(this.filterSelect)

        return filterWrapper
    }

    generateFilterDropDown() {
        this.filterSelect.id = "filter-by-state"
        this.filterSelect.append(this.generateFilterOption("", "All"))
        this.generateAllFilterOptions()
        this.main.querySelector('slider-component').prepend(this.generateFilterWrapper())
    }

    toggleClass(className, displayState){
        const elements = document.getElementsByClassName(className)
        for (let el of elements){
            el.style.display = displayState;
        }
    }
    initFilterEvents() {
        this.filterSelect.addEventListener("change", (el) => {
            if (el.target.value !== '') {
                //console.log(el.target.value)
                this.toggleClass('multicolumn-list__item grid__item', 'none');
                this.toggleClass(el.target.value, 'block');
            } else {
                this.toggleClass('multicolumn-list__item grid__item', 'block');
            }
        })
    }
}
let filter = new StateFilter()
filter.initFilter()